// src/services/InspectionService.js
// FIXED: Removed all broken markdown link syntax including:
//   [api.post](http://api.post)  →  api.post
//   [response.data](http://response.data)  →  response.data
//   [inspectionData.contact](http://inspectionData.contact)_person  →  inspectionData.contact_person
//   [inspectionData.city](http://inspectionData.city)  →  inspectionData.city

import api from './api';
import { paymentService } from './paymentService';

export const inspectionService = {
  bookInspection: async (inspectionData) => {
    try {
      const response = await api.post('/car_inspections', {
        sell_request_id:      inspectionData.sell_request_id,
        inspection_type:      inspectionData.inspection_type,
        seller_address:       inspectionData.seller_address,
        branch_location:      inspectionData.branch_location,
        preferred_date:       inspectionData.preferred_date,
        preferred_time:       inspectionData.preferred_time,
        contact_person:       inspectionData.contact_person,
        contact_phone:        inspectionData.contact_phone,
        city:                 inspectionData.city,
        special_instructions: inspectionData.special_instructions,
      });
      return response.data;
    } catch (error) {
      console.error('Inspection booking error:', error);
      throw error.response?.data || error;
    }
  },

  getInspections: async () => {
    try {
      const response = await api.get('/car_inspections');
      const inspections = response.data?.data || [];
      const enhanced = await Promise.all(
        inspections.map(async (inspection) => {
          const paymentRes = await paymentService.getInspectionPayment(inspection.id);
          if (!paymentRes?.data) {
            return { ...inspection, payment: null };
          }
          return {
            ...inspection,
            payment: {
              status:              paymentRes.data.status,
              razorpay_payment_id: paymentRes.data.razorpay_payment_id,
              razorpay_order_id:   paymentRes.data.razorpay_order_id,
              amount_cents:        paymentRes.data.amount_cents,
              updated_at:          paymentRes.data.updated_at,
            },
          };
        })
      );
      return { data: enhanced };
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  getInspection: async (id) => {
    const response = await api.get(`/car_inspections/${id}`);
    const inspection = response.data?.data || response.data;
    const paymentRes = await paymentService.getInspectionPayment(id);
    return { ...inspection, payment: paymentRes?.data || null };
  },

  getInspectionPayment: async (inspectionId) => {
    try {
      const response = await api.get(`/payments/inspection/${inspectionId}`);
      return response.data;
    } catch (error) {
      console.error('Get inspection payment error:', error);
      return null;
    }
  },

  updateInspection: async (id, data) => {
    try {
      const response = await api.patch(`/car_inspections/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Update inspection error:', error);
      throw error.response?.data || error;
    }
  },

  cancelInspection: async (id) => {
    try {
      const response = await api.delete(`/car_inspections/${id}`);
      return response.data;
    } catch (error) {
      console.error('Cancel inspection error:', error);
      throw error.response?.data || error;
    }
  },
};